import React, { useContext, useEffect, useState } from 'react'
import DateConverter from '../Tools/DateConverter';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import ContenidoFormulario from './ContenidoFormulario';
import { contextFormulario } from './PrincipalFormulario';
import xlsx from 'sheetjs-style'
import * as FileSaver from 'file-saver'
const server = process.env.REACT_APP_SERVER;
function RespuestasFormulario() {
    const { selectItem, setVentana, regional, setLoader, selectRespuesta,setSelectRespuesta, verRespuesta, setVerRespuesta } = useContext(contextFormulario);
    const [respuestas, setRespuestas] = useState([]);
    const [preguntas, setPreguntas] = useState([]);
    function verRespuestaEmpleado(dato) {
        setSelectRespuesta(dato);
        setVerRespuesta(true);
    }
    function buscarColaborador() {
        var input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("buscarRespuestaE");
        filter = input.value.toUpperCase();
        table = document.getElementById("respuestasColaborado");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[0];
            if (td) {
                txtValue = td.getElementsByTagName('div')[1].getElementsByTagName('div')[0].innerHTML;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    async function exportarExcel() {
        var datosExcel = [];
        for (var res of respuestas) {
            var obj = {
                "NOMBRE": res.NOMBREX,
                "GENERO":res.GENERO,
                "AREA": res.AREA,
                "CARGO": res.CARGO,
                "SUCURSAL":res.SUCURSAL,
                "FECHA INGRESO":res.EMPRESA_FECHA_INGRESO.substring(0,10)
            }
            getRespuestaUsuario(obj, res.RESPUESTA)
            datosExcel.push(obj)
        }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtencion = '.xlsx';
        const ws = xlsx.utils.json_to_sheet(datosExcel);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        var fechaDescarga = new Date()
        FileSaver.saveAs(data, `${selectItem.TIPO_ENCUESTA}_${fechaDescarga.toISOString().substring(0,10)}` + fileExtencion);
    }
    function getRespuestaUsuario(obj, datos) {
        for (var preg of preguntas) {
            var info = datos.filter((item) => item.ID_PREGUNTA === preg.ID_PREGUNTA);
            if (info.length!=0) {
                if (preg.TIPO === 'S') {
                    obj[UtilsBufer.getText(preg.DESCRIPCION)] = UtilsBufer.getText(info[0].NOMBRE_OPCION);
                } else if(preg.TIPO==='M'){
                    var auxf = info.filter((item) => item.ID_OPCION!=0);
                    var respp=''
                    for(var item of auxf){
                        respp+=UtilsBufer.getText(item.NOMBRE_OPCION)+' ; ';
                    }
                    obj[UtilsBufer.getText(preg.DESCRIPCION)]=respp.slice(0, -2);
                }else if(['R','F','H'].includes(preg.TIPO)==true){
                    obj[UtilsBufer.getText(preg.DESCRIPCION)] = UtilsBufer.getText(info[0].DESCRIPCION);
                }else if(preg.TIPO=='O'){
                    var resp =''
                    var filtroInfo = info.filter(item=>item.ID_OPCION!=0);
                    for(var item of filtroInfo){
                        resp+=UtilsBufer.getText(item.NOMBRE_OPCION)+':'+UtilsBufer.getText(item.DESCRIPCION)+' ; '
                    }
                    obj[UtilsBufer.getText(preg.DESCRIPCION)]=resp.slice(0, -2);
                }
            } else {
                obj[UtilsBufer.getText(preg.DESCRIPCION)] = '';
            }
        }
    }
    function getPregunta() {
        fetch(`${server}/formulario/getPreguntas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, "ID_ENCUESTA": selectItem.ID_ENCUESTA
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setPreguntas(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
                //setLoader(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    useEffect(() => {
        //setLoader(true);
        fetch(`${server}/formulario/getRespuestas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, "ID_ENCUESTA": selectItem.ID_ENCUESTA
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setRespuestas(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err))
            .finally(
                getPregunta()
            );
    }, [])
    return (
        <>
            {verRespuesta === false && <>
            <div className='container-fluid text-light bg-dark'>
                <div className='row row-cols g-0 py-1'>
                    <div className='col-10 my-auto'>
                        RESPUESTAS DEL FORMULARIO ** {selectItem.TITULO} **
                    </div>
                    <div className='col-2'>
                        <button className='btn btn-sm btn-success w-100' onClick={() => exportarExcel()}
                            data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Exportar a Excel"><i className="fa-solid fa-file-excel"></i> EXCEL</button>
                    </div>
                    <div className='col-6 col-md-2 text-end my-auto d-none'>
                        <button className='btn btn-sm text-danger' onClick={() => setVentana(0)}>
                            <i className="fa-solid fa-circle-xmark fa-2xl"></i>
                        </button>
                    </div>
                </div>
            </div>
                <div className='table-responsive '>
                    <table className="table table-dark table-sm table-hover table-striped" id="respuestasColaborado">
                        <thead>
                            <tr>
                                <th className='col-6'>
                                    <div className='container-fluid py-0 m-0'>
                                        <input className="form-control form-control-sm"
                                            placeholder='Buscar Colaborador'
                                            type="text"
                                            id="buscarRespuestaE"
                                            onChange={() => buscarColaborador()} />
                                    </div>
                                </th>
                                <th scope="col">Fecha de respuesta</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody >
                            {respuestas.map((item, index) => {
                                return (
                                    <tr key={index} className='my-auto'>
                                        <td className='col-4'>
                                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                                                {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                                <div className='ps-2 my-auto d-none d-sm-inline'>
                                                    <div className="cargoHeader fw-bold" id="nameBuscar">{item.NOMBREX}</div>
                                                    <div className='cargoHeader '>{item.CARGO}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='col-3'>{DateConverter.formatoFecha(item.RESPUESTA[0].FECHA)}</td>
                                        <td className='text-end'>
                                            <button className='btn btn-sm btn-warning bg-gradient' onClick={() => verRespuestaEmpleado(item)}>
                                                <i className="fa-regular fa-eye"></i> ver
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </>}
            {verRespuesta &&<div className='overflow-auto'>
                <ContenidoFormulario selectItem={selectItem} selectRespuesta={selectRespuesta} setSelectRespuesta={setSelectRespuesta}
                setVentana={()=>setVerRespuesta(false)} regional={regional} soloVer={verRespuesta} setVerRespuesta={setVerRespuesta} setLoader={() => { }}/>
            </div>
            }
        </>
    )
}

export default RespuestasFormulario
